import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import {
  GetCityListPayloadType,
  LeadInfoDetailsType,
  SelectStageOptionType,
  StageDetailsType,
} from "../../../commonTypes/clientDirectoryTypes";
import useDebounce from "../../../customHooks/useDebounce";
import { getAllFinacUsersAction } from "../../../redux/auth";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import { RootState } from "../../../redux/rootReducers";
import {
  formateDateAndTime,
  reverseDate,
} from "../../../utils/commonFunctions";
import { SelctOptionType } from "../../DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
import { RadioContainer, ToggleSwitch } from "../../commons";
import CompanyDetails from "./CompanyDetails";
import LeadDetails from "./LeadDetails";
import LeadInfo from "./LeadInfo";
import { RADIO_OPTIONS } from "../../../screens/LeadModule/EditLeadModule";
import ScopeOfWorkDetails from "./ScopeOfWorkDetails";
import { getMasterDataScopeOfWorkAction } from "../../../redux/masterData";
import { GetUsersDepartmentPayloadType } from "../../../commonTypes/masterDataTypes";
import { ScopeOfWorkListType } from "../../../redux/masterData/masterTypes";
import { PaperClipIcon } from "../../Icon";
import { StockUploadFilePayloadType } from "../../../commonTypes/clientSettingsTypes";
import {
  multipleUploadFilesAction,
  resetMultipleFileUploadData,
  resetMultipleFileUploadError,
  resetMultipleFileUploadFetching,
  resetMultipleFileUploadSuccess,
} from "../../../redux/clientSettings";
import { GetGenerateSasTokenPayloadType } from "../../../commonTypes/stcoToolsType";
import {
  getTokenGenerateForDownloadAction,
  resetSasTokenForDownloadFile,
} from "../../../redux/stcoTools";
import MultiUploadWithApi from "../../commons/UploadFileWithApi/MultiUploadWithApi";
import MultiFilePreviewModal from "../../commons/MultiPreviewWithApi/MultiFilePreviewModal";
import { MulitpleFileUploadData } from "../../../redux/clientSettings/clientSettingTypes";
import FileUploadErrorModal from "../../commons/FileUploadErrorModal";
import {
  getStageListAction,
  resetLeadStageList,
} from "../../../redux/clientDirectory";

type AppProps = {
  history: any;
  token: string | null;
  fetching: boolean;
  finacUser: any;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  handleSubmitLeadModule: (data: LeadInfoDetailsType) => void;
  singleClientleadDirectoryDetails: any;
  loginData: LoginResponseType;
  dispatchGetMasterDataScopeOfWorkAction: (
    data: GetUsersDepartmentPayloadType
  ) => void;
  scopeOfWorkList: ScopeOfWorkListType[] | [];
  scopeOfWorkTotalCount: number;
  fileUploadData: MulitpleFileUploadData[] | [];
  fileUploadFetching: boolean;
  fileUploadSuccess: number | null;
  fileUploadError: string | null;
  sasTokenForDownloadFile: string;
  dispatchUploadFilesAction: (data: StockUploadFilePayloadType) => void;
  dispatchResetStockFileUploadFetching: () => void;
  dispatchResetStockFileUploadData: () => void;
  dispatchResetStockFileUploadSuccess: () => void;
  dispatchResetStockFileUploadError: () => void;
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => void;
  dispatchResetSasTokenForDownloadFile: () => void;
  dispatchLeadStageData: (data: GetCityListPayloadType) => void;
  dispatchResetLeadStageData: () => void;
  leadStageData: StageDetailsType[];
};

const LeadModuleForm = ({
  history,
  token,
  fetching,
  finacUser,
  loginData,
  dispatchGetAllFinacUsersAction,
  handleSubmitLeadModule,
  singleClientleadDirectoryDetails,
  dispatchGetMasterDataScopeOfWorkAction,
  scopeOfWorkList,
  scopeOfWorkTotalCount,
  fileUploadData,
  fileUploadFetching,
  fileUploadSuccess,
  fileUploadError,
  sasTokenForDownloadFile,
  dispatchUploadFilesAction,
  dispatchResetStockFileUploadFetching,
  dispatchResetStockFileUploadData,
  dispatchResetStockFileUploadSuccess,
  dispatchResetStockFileUploadError,
  leadStageData,
  dispatchLeadStageData,
  dispatchResetLeadStageData,
}: AppProps) => {
  const filterData = history?.location?.state?.multiSelectData;
  const sortByLeadReceivedOn = history?.location?.state?.sortByLeadReceivedOn;
  const sortByStage = history?.location?.state?.sortByStage;
  const searchData = history?.location?.state?.searchData;

  const [text, setText] = useState<string>("");
  const [limit, setLimit] = useState<number>(50);
  const [offset, setoffset] = useState<number>(0);
  const [finalUserList, setFinalUserList] = useState<any>([]);
  const [finalUserWithLoginUserList, setFinalUserWithLoginUserList] =
    useState<any>([]);
  const [selectedAccessTeam, setSelectedAccessTeam] = useState<number[] | []>(
    []
  );
  const [userSelected, setUserSelected] = useState<SelctOptionType[]>([]);
  let containerName: string | undefined =
    process.env.REACT_APP_USER_CONTAINER_NAME;
  const [uploadSuccessArray, setUploadSuccessArray] = useState<any>([]);
  const [uploadData, setUploadData] = useState<any>([]);
  const [imageDetails, setImageDetails] = useState<any>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  const [showImagePreview, setShowImagePreview] = useState<boolean>(false);
  const [showPopUpContentModal, setShowPopUpContentModal] =
    useState<boolean>(false);

  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;
  const [leadInfoBasicDetails, setLeadInfoBasicDetails] = useState({
    entity: "",
    firstName: "",
    lastName: "",
    name: "",
    city: "",
    businessNature: "",
    turnOver: "",
  });
  const [finalScopeOfWorkList, setFinalScopeOfWorkList] = useState<any>([]);
  const [scopeOfWorkOffset, setScopeOfWorkOffset] = useState<number>(0);
  const [scopeOfWorkLimit, setScopeOfWorkLimit] = useState<number>(20);
  const [searchValue, setSearchValue] = useState("");
  const [scopeOfWorkText, setScopeOfWorkText] = useState("");
  const [stageDropDown, setStageDropDown] = useState<
    SelectStageOptionType[] | []
  >([]);
  const [selectedScopeOfWork, setSelectedScopeOfWork] = useState<number[] | []>(
    []
  );
  const [scopeOfWork, setScopeOfWork] = useState<SelctOptionType[]>([]);
  const [showUploadModal, setShowUploadModal] = useState<boolean>(false);
  const [allFileData, setAllFileData] = useState<any>("");

  const [leadInfoDetails, setLeadInfoDetails] = useState<LeadInfoDetailsType>({
    leadInfo: {
      leadReceivedOn: "",
      leadAssignedTo: {
        value: null,
        label: "Select..",
      },
      demoAssignedTo: {
        value: null,
        label: "Select..",
      },
      meetingAssignedTo: {
        value: null,
        label: "Select..",
      },
      meetingTimewithDate: "",
      finacMigrateStatus: "no",
      followUpDateWithTime: "",
    },
    leadDetails: {
      response: "",
      source: "",
      feedback: "",
      uniqueId:null,
      stage: {
        value: null,
        label: "Select..",
      },
      callFrequency: {
        value: null,
        label: "Select..",
      },
      leadCategary: {
        value: null,
        label: "Select..",
      },
      status:true
    },
    companyDetails: {
      companyName: "",
      contactPersonName: "",
      contactNumber: "",
      emailId: "",
      gstNumberRegister: false,
    },
    scopeOfWorkDetails: {
      scopeOfWork: [],
    },
    // attachments:[]
  });
  const tab = history?.location?.state?.tab;

  useEffect(() => {
    dispatchResetStockFileUploadFetching();
    dispatchResetStockFileUploadData();
    dispatchResetStockFileUploadSuccess();
    dispatchResetStockFileUploadError();
    setAllFileData([]);
    dispatchResetLeadStageData();
    if (token) {
      dispatchLeadStageData({ token });
    }
  }, []);
  useEffect(() => {
    const data = finacUser?.data?.filter(
      (e: any) => e?.user_id !== loginData?.user_id
    );
    const finalUserData = data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name} ${user?.last_name}`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (offset > 0) {
      setFinalUserList([...finalUserList, ...finalUserData]);
    } else {
      setFinalUserList(finalUserData);
    }
  }, [finacUser]);

  // scope of work
  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        limit: scopeOfWorkLimit,
        offset: scopeOfWorkOffset,
        searchValue: scopeOfWorkText,
        status: 1,
      };
      dispatchGetMasterDataScopeOfWorkAction(finalUserData);
    }
  }, []);

  useEffect(() => {
    const finalScopeOfWorkData = scopeOfWorkList?.map((scope: any) => {
      return {
        value: scope?._id,
        label: scope?.scope_of_work_name,
      };
    });
    if (scopeOfWorkOffset > 0) {
      setFinalScopeOfWorkList([
        ...finalScopeOfWorkList,
        ...finalScopeOfWorkData,
      ]);
    } else {
      setFinalScopeOfWorkList(finalScopeOfWorkData);
    }
  }, [scopeOfWorkList]);
  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        limit: scopeOfWorkLimit,
        offset: scopeOfWorkOffset,
        searchValue: scopeOfWorkText,
        status: 1,
      };
      if (scopeOfWorkOffset <= scopeOfWorkTotalCount) {
        dispatchGetMasterDataScopeOfWorkAction(finalUserData);
      }
    }
  }, [scopeOfWorkOffset]);

  const fetchNewCategoryData = (search: string) => {
    const finalData = {
      token,
      limit: scopeOfWorkLimit,
      offset: scopeOfWorkOffset,
      searchValue: scopeOfWorkText,
      status: 1,
    };
    dispatchGetMasterDataScopeOfWorkAction(finalData);
  };

  useDebounce(
    () => {
      if (scopeOfWorkText) {
        fetchNewCategoryData(scopeOfWorkText);
      } else {
        const finalData = {
          token,
          limit: scopeOfWorkLimit,
          offset: scopeOfWorkOffset,
          searchValue: scopeOfWorkText,
          status: 1,
        };
        dispatchGetMasterDataScopeOfWorkAction(finalData);
      }
    },
    500,
    [scopeOfWorkText]
  );

  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name} ${user?.last_name}`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (offset > 0) {
      setFinalUserWithLoginUserList([...finalUserList, ...finalUserData]);
    } else {
      setFinalUserWithLoginUserList(finalUserData);
    }
  }, [finacUser]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset,
        limit,
        user_type: "stco_users",
        status: 1,
        search_term: text,
      };
      if (offset <= finacUser?.total_count) {
        dispatchGetAllFinacUsersAction(finalUserData);
      }
    }
  }, [offset]);

  useEffect(() => {
    if (
      leadInfoDetails?.attachments &&
      leadInfoDetails?.attachments?.length > 0
    ) {
      setUploadData([...leadInfoDetails?.attachments]);
    } else {
      setUploadData([]);
    }
  }, [leadInfoDetails?.attachments, leadInfoDetails]);

  useEffect(() => {
    setLeadInfoDetails((prv: any) => {
      return {
        ...prv,
        scopeOfWorkDetails: {
          ...prv.scopeOfWorkDetails,
          scopeOfWork: scopeOfWork,
        },
      };
    });
  }, [scopeOfWork]);

  const handleSetRadioValue = (radioValue: string) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadInfo: {
          ...prev.leadInfo,
          finacMigrateStatus: radioValue,
        },
      };
    });
  };
  useEffect(() => {
    if (singleClientleadDirectoryDetails) {
      setLeadInfoBasicDetails({
        entity: singleClientleadDirectoryDetails?.entity
          ? singleClientleadDirectoryDetails?.entity
          : "--/--",
        firstName: singleClientleadDirectoryDetails?.first_name
          ? singleClientleadDirectoryDetails?.first_name
          : "--/--",
        lastName: singleClientleadDirectoryDetails?.last_name
          ? singleClientleadDirectoryDetails?.last_name
          : "--/--",
        name: singleClientleadDirectoryDetails?.company_name
          ? singleClientleadDirectoryDetails?.company_name
          : "--/--",
        city: singleClientleadDirectoryDetails?.city
          ? singleClientleadDirectoryDetails?.city
          : "--/--",
        businessNature: singleClientleadDirectoryDetails?.business_nature
          ? singleClientleadDirectoryDetails?.business_nature
          : "",
        turnOver: singleClientleadDirectoryDetails?.turnover_in_crores
          ? singleClientleadDirectoryDetails?.turnover_in_crores
          : "",
      });
      const scopeOfWorkData = singleClientleadDirectoryDetails?.scope_of_work;
      if (scopeOfWorkData && scopeOfWorkData.length > 0) {
        const scopeOfWorkOptions = scopeOfWorkData.map((scope: any) => ({
          value: scope?._id,
          label: scope?.scope_of_work_name,
        }));
        setScopeOfWork(scopeOfWorkOptions);
      } else {
        setScopeOfWork([]);
      }
      setLeadInfoDetails((prev: any) => {
        return {
          ...prev,
          leadInfo: {
            leadReceivedOn: singleClientleadDirectoryDetails?.lead_received_on
              ? reverseDate(singleClientleadDirectoryDetails?.lead_received_on)
              : null,
            leadAssignedTo: {
              value:
                singleClientleadDirectoryDetails?.lead_assigned_to?.user_id,
              label: singleClientleadDirectoryDetails?.lead_assigned_to
                ?.first_name
                ? `${singleClientleadDirectoryDetails?.lead_assigned_to?.first_name} ${singleClientleadDirectoryDetails?.lead_assigned_to?.last_name}`
                : "Select..",
            },
            demoAssignedTo: {
              value:
                singleClientleadDirectoryDetails?.demo_assigned_to?.user_id,
              label: singleClientleadDirectoryDetails?.demo_assigned_to?.user_id
                ? `${singleClientleadDirectoryDetails?.demo_assigned_to?.first_name} ${singleClientleadDirectoryDetails?.demo_assigned_to?.last_name}`
                : "Select..",
            },
            meetingAssignedTo: {
              value:
                singleClientleadDirectoryDetails?.meeting_assigned_to?.user_id,
              label: singleClientleadDirectoryDetails?.meeting_assigned_to
                ?.user_id
                ? `${singleClientleadDirectoryDetails?.meeting_assigned_to?.first_name} ${singleClientleadDirectoryDetails?.meeting_assigned_to?.last_name}`
                : "Select..",
            },
            meetingTimewithDate: singleClientleadDirectoryDetails?.meeting_time
              ? formateDateAndTime(
                  singleClientleadDirectoryDetails?.meeting_time
                )
              : null,
            finacMigrateStatus:
              singleClientleadDirectoryDetails?.finac_migration_status
                ? "Yes"
                : "No",
            followUpDateWithTime:
              singleClientleadDirectoryDetails?.follow_up_date
                ? formateDateAndTime(
                    singleClientleadDirectoryDetails?.follow_up_date
                  )
                : null,
          },
          leadDetails: {
            response: singleClientleadDirectoryDetails?.lead_details?.response,
            source: singleClientleadDirectoryDetails?.lead_details?.source,
            feedback: singleClientleadDirectoryDetails?.lead_details?.feedback,
            uniqueId: singleClientleadDirectoryDetails?.lead_details?.lead_stage_unique_id,
            stage: {
              value: singleClientleadDirectoryDetails?.lead_details?.stage_id,
              label: singleClientleadDirectoryDetails?.lead_details?.stage
                ? singleClientleadDirectoryDetails?.lead_details?.stage
                : "Select..",
            },
            callFrequency: {
              value:
                singleClientleadDirectoryDetails?.lead_details?.call_frequency,
              label: singleClientleadDirectoryDetails?.lead_details
                ?.call_frequency
                ? singleClientleadDirectoryDetails?.lead_details?.call_frequency
                : "Select..",
            },
            leadCategary: {
              value:
                singleClientleadDirectoryDetails?.lead_details?.lead_category,
              label: singleClientleadDirectoryDetails?.lead_details
                ?.lead_category
                ? singleClientleadDirectoryDetails?.lead_details?.lead_category
                : "Select..",
            },
          },
          companyDetails: {
            companyName:
              singleClientleadDirectoryDetails?.company_details?.company_name,
            contactPersonName:
              singleClientleadDirectoryDetails?.company_details
                ?.contact_person_name,
            contactNumber:
              singleClientleadDirectoryDetails?.company_details?.contact_number,
            emailId: singleClientleadDirectoryDetails?.company_details?.email,
            gstNumberRegister:
              singleClientleadDirectoryDetails?.company_details
                ?.gst_number_registered,
          },
          scopeOfWorkDetails: {
            scopeOfWork: scopeOfWork,
          },

          // attachments: singleClientleadDirectoryDetails?.attachments,
        };
      });
      if (singleClientleadDirectoryDetails?.access_members) {
        let totalUser = singleClientleadDirectoryDetails?.access_members?.map(
          (e: any) => {
            return {
              value: e?.user_id,
              label: `${e?.first_name} ${e?.last_name ? e?.last_name : ""}`,
            };
          }
        );
        const accessTeamMembersId =
          singleClientleadDirectoryDetails?.access_members?.map(
            (e: any) => e?.user_id
          );
        setSelectedAccessTeam(accessTeamMembersId);
        setUserSelected(totalUser);
      } else {
        setSelectedAccessTeam([]);
        setUserSelected([]);
      }
      if (
        singleClientleadDirectoryDetails?.attachments &&
        singleClientleadDirectoryDetails?.attachments?.length > 0
      ) {
        setAllFileData([...singleClientleadDirectoryDetails?.attachments]);
      }
    }
  }, [singleClientleadDirectoryDetails]);

  useEffect(() => {
    if (leadStageData?.length > 0) {
      let finalData = leadStageData?.map((item: StageDetailsType) => {
        return {
          label: item?.stage_name,
          value: item?._id,
          uniqueId: item?.unique_id
        };
      });
      setStageDropDown([...finalData]);
    }
  }, [leadStageData]);

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: text,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  useDebounce(
    () => {
      if (text) {
        fetchNewData(text);
      } else {
        const finalData = {
          token,
          offset,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: text,
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [text]
  );

  const handleCompanyDetailsChange = (e: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        companyDetails: {
          ...prev.companyDetails,
          [e.target.name]: e.target.value,
        },
      };
    });
  };

  const handleLeadDetailsChange = (e: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadDetails: {
          ...prev.leadDetails,
          [e.target.name]: e.target.value,
        },
      };
    });
  };
  const handleLeadInfoDetailsChange = (e: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadInfo: {
          ...prev.leadInfo,
          [e.target.name]: e.target.value,
        },
      };
    });
  };
  const handleLeadAssignedToChange = (data: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadInfo: {
          ...prev.leadInfo,
          leadAssignedTo: {
            value: data?.value,
            label: data?.label,
          },
        },
      };
    });
  };
  const handleDemoAssignedToChange = (data: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadInfo: {
          ...prev.leadInfo,
          demoAssignedTo: {
            value: data?.value,
            label: data?.label,
          },
        },
      };
    });
  };
  const handleLeadReceivedOnChange = (date: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadInfo: {
          ...prev.leadInfo,
          leadReceivedOn: date === "Invalid date" ? null : date,
        },
      };
    });
  };

  const handleMeetingAssignedToChange = (data: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadInfo: {
          ...prev.leadInfo,
          meetingAssignedTo: {
            value: data?.value,
            label: data?.label,
          },
        },
      };
    });
  };

  const handleStageChange = (data: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadDetails: {
          ...prev.leadDetails,
          stage: {
            value: data?.value,
            label: data?.label,
          },
          uniqueId: data?.uniqueId
        },
      };
    });
  };
  const handleCallFrequencyChange = (data: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadDetails: {
          ...prev.leadDetails,
          callFrequency: {
            value: data?.value,
            label: data?.label,
          },
        },
      };
    });
  };
  const handleLeadCategaryChange = (data: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadDetails: {
          ...prev.leadDetails,
          leadCategary: {
            value: data?.value,
            label: data?.label,
          },
        },
      };
    });
  };
  const handleToggleIsMaintenance = () => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        companyDetails: {
          ...prev.companyDetails,
          gstNumberRegister:
            !leadInfoDetails?.companyDetails?.gstNumberRegister,
        },
      };
    });
  };

  const handleScopeOfWorkChange = (e: any) => {
    let scopeOfWorkIdName: any = e?.map((e: any) => {
      return e?.value;
    });
    let totalUser = e?.map((e: any) => {
      return {
        value: e?.value,
        label: e?.label,
      };
    });
    setScopeOfWork(totalUser);

    setSelectedScopeOfWork(scopeOfWorkIdName);
  };
  const handleBusinessNatureChange = (data: string) => {
    setLeadInfoBasicDetails((prev: any) => {
      return {
        ...prev,
        businessNature: data,
      };
    });
  };
  const handleTurnOverChange = (data: any) => {
    setLeadInfoBasicDetails((prev: any) => {
      return {
        ...prev,
        [data.target.name]: data.target.value,
      };
    });
  };
  const updatedLeadInfoDetails = { ...leadInfoDetails };
  const handleLeadDirectoryFormSubmit = () => {
    if (
      updatedLeadInfoDetails &&
      updatedLeadInfoDetails.scopeOfWorkDetails &&
      updatedLeadInfoDetails.scopeOfWorkDetails.scopeOfWork
    ) {
      updatedLeadInfoDetails.scopeOfWorkDetails.scopeOfWork.forEach(
        (scope: any) => {
          if (scope.hasOwnProperty("value") && scope.hasOwnProperty("label")) {
            scope._id = scope.value;
            scope.scope_of_work_name = scope.label;

            delete scope.value;
            delete scope.label;
          }
        }
      );
    }
    const leadInfoDetails = {
      ...updatedLeadInfoDetails,
    };
    Object.keys(leadInfoDetails).forEach((key) => {
      leadInfoDetails["attachments"] = allFileData;
    });

    if (token) {
      const finalData = {
        businessNature: leadInfoBasicDetails?.businessNature,
        turnOver: leadInfoBasicDetails?.turnOver,
        accessTeamMembersId: selectedAccessTeam,
        ...leadInfoDetails,
      };
      handleSubmitLeadModule(finalData);
    }
  };
  const handleFileChange = (file: any) => {
    // setFileData(file);

    const finalData = {
      token,
      fileData: file,
      containerType: 2,
    };

    return dispatchUploadFilesAction(finalData);
  };

  const handleToggleUploadModal = (e: any) => {
    e.preventDefault();
    setShowUploadModal(!showUploadModal);
  };
  return (
    <>
      <div
        style={{
          backgroundColor: "white",
          paddingTop: "23px",
          border: "1px solid #bfcbe1",
          borderRadius: "6px",
        }}
      >
        <div className="row  ml-2">
          <div className="col-md-4">
            <h5 style={{ fontSize: "20px", color: "#262a44" }}>Lead Info</h5>
            <p style={{ color: "#7c8db0", fontSize: "13px" }}>
              Update your lead related details here
            </p>
          </div>
        </div>
        <div
          className="row ml-4 d-flex flex-column mb-2"
          style={{
            border: "1px solid #bfcbe1",
            width: "85%",
            borderRadius: "6px",
          }}
        >
          <div className="ml-3 mt-3">
            <h5 style={{ fontSize: "15px", color: "#262a44" }}>
              BASIC DETAILS
            </h5>
          </div>
          <div
            className="d-flex row justify-content-between ml-3 mb-3"
            style={{ width: "95%" }}
          >
            <div className="d-flex flex-column">
              <span style={{ color: "#6e7491", fontSize: "13px" }}>Entity</span>
              <span style={{ color: "#262a44", fontSize: "14px" }}>
                {leadInfoBasicDetails?.entity}
              </span>
            </div>
            <div className="d-flex flex-column">
              <span style={{ color: "#6e7491", fontSize: "13px" }}>
                First Name
              </span>
              <span style={{ color: "#262a44", fontSize: "14px" }}>
                {leadInfoBasicDetails?.firstName}
              </span>
            </div>
            <div className="d-flex flex-column">
              <span style={{ color: "#6e7491", fontSize: "13px" }}>
                Last Name
              </span>
              <span style={{ color: "#262a44", fontSize: "14px" }}>
                {leadInfoBasicDetails?.lastName}
              </span>
            </div>
            <div className="d-flex flex-column">
              <span style={{ color: "#6e7491", fontSize: "13px" }}>Name</span>
              <span style={{ color: "#262a44", fontSize: "14px" }}>
                {leadInfoBasicDetails?.name}
              </span>
            </div>
            <div className="d-flex flex-column">
              <span style={{ color: "#6e7491", fontSize: "13px" }}>City</span>
              <span style={{ color: "#262a44", fontSize: "14px" }}>
                {leadInfoBasicDetails?.city}
              </span>
            </div>
            <div className="d-flex flex-column">
              <span style={{ color: "#6e7491", fontSize: "13px" }}>
                Client Category
              </span>
              <span style={{ color: "#262a44", fontSize: "14px" }}>
                {singleClientleadDirectoryDetails?.client_category?.length
                  ? singleClientleadDirectoryDetails?.client_category?.map(
                      (el: any) => {
                        return <div>{el}</div>;
                      }
                    )
                  : "NA"}
              </span>
            </div>
          </div>
        </div>

        <LeadInfo
          setoffset={setoffset}
          limit={limit}
          setText={setText}
          fetching={fetching}
          finalUserList={finalUserList}
          finalUserWithLoginUserList={finalUserWithLoginUserList}
          handleLeadInfoDetailsChange={handleLeadInfoDetailsChange}
          handleLeadAssignedToChange={handleLeadAssignedToChange}
          handleDemoAssignedToChange={handleDemoAssignedToChange}
          handleLeadReceivedOnChange={handleLeadReceivedOnChange}
          handleMeetingAssignedToChange={handleMeetingAssignedToChange}
          leadInfoBasicDetails={leadInfoBasicDetails}
          handleBusinessNatureChange={handleBusinessNatureChange}
          setLeadInfoDetails={setLeadInfoDetails}
          leadInfo={leadInfoDetails?.leadInfo}
          setSelectedAccessTeam={setSelectedAccessTeam}
          selectedAccessTeam={selectedAccessTeam}
          userSelected={userSelected}
          setUserSelected={setUserSelected}
          loginData={loginData}
          handleTurnOverChange={handleTurnOverChange}
        />
        <LeadDetails
          handleLeadDetailsChange={handleLeadDetailsChange}
          handleStageChange={handleStageChange}
          handleCallFrequencyChange={handleCallFrequencyChange}
          handleLeadCategaryChange={handleLeadCategaryChange}
          leadDetails={leadInfoDetails?.leadDetails}
          stageDropDown={stageDropDown}
        />
        <br />
        <CompanyDetails
          handleCompanyDetailsChange={handleCompanyDetailsChange}
          companyDetails={leadInfoDetails?.companyDetails}
        />
        <ScopeOfWorkDetails
          scopeOfWork={scopeOfWork}
          setScopeOfWork={setScopeOfWork}
          selectedScopeOfWork={selectedScopeOfWork}
          setSelectedScopeOfWork={setSelectedScopeOfWork}
          handleScopeOfWorkChange={handleScopeOfWorkChange}
          finalScopeOfWorkList={finalScopeOfWorkList}
          setScopeOfWorkText={setScopeOfWorkText}
          setScopeOfWorkOffset={setScopeOfWorkOffset}
          scopeOfWorkLimit={scopeOfWorkLimit}
          fetching={fetching}
          loginData={loginData}
        />
        <br />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "35px",
          }}
        >
          {showUploadModal ? (
            <MultiUploadWithApi
              modal={showUploadModal}
              toggleModal={handleToggleUploadModal}
              token={token}
              handleFileChange={handleFileChange}
              isDraggableModal
              acceptedFiles={
                "image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"
              }
              maxFileSize={2000000}
              supportedFiles="PNG, JPEG, PDF, Excel, PPT, PPTX and Doc."
              multipleFileUploadData={fileUploadData}
              multipleFileUploadFetching={fileUploadFetching}
              allFileData={allFileData}
              setAllFileData={setAllFileData}
              multipleFileUploadSuccess={fileUploadSuccess}
              dispatchResetMultipleFileUploadSuccess={
                dispatchResetStockFileUploadSuccess
              }
              dispatchResetMultipleFileUploadError={
                dispatchResetStockFileUploadError
              }
            />
          ) : null}

          <span className="ml-4">Ready to migrate in finac</span>
          <div className="ml-4">
            <RadioContainer
              optionsList={RADIO_OPTIONS}
              handleSetRadioValue={handleSetRadioValue}
              radioValue={
                leadInfoDetails?.leadInfo?.finacMigrateStatus
                  ? leadInfoDetails?.leadInfo?.finacMigrateStatus
                  : ""
              }
              alignment="horizontal"
            />
          </div>

          <span className="ml-5">Do you have registered GST Number?</span>
          <div className="ml-4">
            <ToggleSwitch
              handleToggleChange={handleToggleIsMaintenance}
              isChecked={leadInfoDetails?.companyDetails?.gstNumberRegister}
            />
          </div>
          <div className="ml-5 d-flex p-0">
            <div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <button
                  className="btn btn-outline"
                  onClick={(e: any) => {
                    handleToggleUploadModal(e);
                  }}
                >
                  + Upload File
                </button>
                <div className="pointer position-relative ml-4">
                  {allFileData?.length ? (
                    <span
                      id="Popover1"
                      onClick={() => setShowImagePreview(true)}
                    >
                      <PaperClipIcon />
                      <span
                        className="badge count-badge"
                        style={{ left: "11px" }}
                      >
                        {allFileData?.length}
                      </span>
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr></hr>
        <div className="row p-3">
          <div className="col-md-12 text-right">
            <button
              className="btn"
              style={{ border: "1px solid #bfcbe1", marginRight: "15px" }}
              onClick={() => {
                history?.push({
                  pathname: "/lead-module/lead-directory-list",
                  search: `?tab=${tab}`,
                  state: {
                    filterData,
                    sortByLeadReceivedOn,
                    sortByStage,
                    searchData,
                    isPersist: true,
                    tab,
                  },
                });
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleLeadDirectoryFormSubmit}
            >
              Save Changes
            </button>
          </div>
        </div>
        <FileUploadErrorModal />
      </div>

      {showImagePreview && (
        <MultiFilePreviewModal
          show={showImagePreview}
          files={allFileData}
          onClose={() => setShowImagePreview(false)}
          token={token}
          setAllFileData={setAllFileData}
          type={"clientDirectory"}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  finacUser: state.auth.finacUsersList,
  fetching: state.auth.fetching,
  scopeOfWorkList: state.masterData.scopeOfWorkList,
  scopeOfWorkTotalCount: state.masterData.scopeOfWorkTotalCount,
  fileUploadData: state.clientSettings.multipleFileUploadData,
  fileUploadFetching: state.clientSettings.multipleFileUploadFetching,
  fileUploadSuccess: state.clientSettings.multipleFileUploadSuccess,
  fileUploadError: state.clientSettings.multipleFileUploadError,
  sasTokenForDownloadFile: state.stcoTools.sasTokenForDownloadFile,
  leadStageData: state.clientDirectory.leadStageList,
});
const dispatchStateToProps = (dispatch: any) => ({
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchGetMasterDataScopeOfWorkAction: (
    data: GetUsersDepartmentPayloadType
  ) => dispatch(getMasterDataScopeOfWorkAction(data)),

  dispatchUploadFilesAction: (data: StockUploadFilePayloadType) =>
    dispatch(multipleUploadFilesAction(data)),
  dispatchResetStockFileUploadFetching: () =>
    dispatch(resetMultipleFileUploadFetching()),
  dispatchResetStockFileUploadData: () =>
    dispatch(resetMultipleFileUploadData()),
  dispatchResetStockFileUploadSuccess: () =>
    dispatch(resetMultipleFileUploadSuccess()),
  dispatchResetStockFileUploadError: () =>
    dispatch(resetMultipleFileUploadError()),
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => dispatch(getTokenGenerateForDownloadAction(data)),
  dispatchResetSasTokenForDownloadFile: () =>
    dispatch(resetSasTokenForDownloadFile()),
  dispatchLeadStageData: (data: GetCityListPayloadType) =>
    dispatch(getStageListAction(data)),
  dispatchResetLeadStageData: () => dispatch(resetLeadStageList()),
});

export default connect(mapStateToProps, dispatchStateToProps)(LeadModuleForm);
